import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

export function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <ErrorMessage error={error} />
    </div>
  );
}

function ErrorMessage({ error }: { error: unknown }) {
  if (isRouteErrorResponse(error)) {
    return (
      <>
        <h2>{error.status}</h2>
        <p>{error.statusText}</p>
        {error.data?.message && <p>{error.data.message}</p>}
      </>
    );
  }

  const errorMessage =
    error instanceof Error
      ? error.message
      : 'Sorry, an unexpected error has occurred.';

  return <p>{errorMessage}</p>;
}
